import { ContentProps } from 'types/content';

export const StandalonePage500: React.FC<ContentProps> = ({ type, data, meta, descendants }) => {
  return (
    <div className="max-w-content mx-auto py-20 text-center">
      <h1>500 Internal Server Error</h1>
    </div>
  );
};
